import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Settings2 } from 'lucide-react';

declare global {
  interface Window {
    usaAdvertising?: {
      ready: Promise<void>;
      allowed: () => boolean;
      state: () => { region: string | null; choice: unknown; needsChoice: boolean };
      choose: (accept: boolean) => void;
    };
  }
}

export default function AdvertisingConsent() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const refresh = () => setOpen(window.usaAdvertising?.state().needsChoice ?? false);
    window.usaAdvertising?.ready.then(refresh);
    window.addEventListener('usa-advertising-change', refresh);
    return () => window.removeEventListener('usa-advertising-change', refresh);
  }, []);
  return <>
    <Button variant="outline" size="icon" className="fixed left-2 bottom-16 z-[60]" aria-label="Preferências de publicidade" title="Preferências de publicidade" onClick={() => setOpen(true)}><Settings2 /></Button>
    {open && <section aria-label="Consentimento de publicidade" className="fixed bottom-28 left-2 right-2 z-[70] mx-auto max-w-xl rounded-md border border-border bg-background p-5 text-foreground shadow-lg">
      <h2 className="text-lg font-semibold">Sua privacidade</h2>
      <p className="my-3 text-sm">Podemos usar cookies e dados de navegação, como páginas visitadas, cliques e identificadores de publicidade, com o Google Ads para medir e otimizar anúncios? Você pode recusar ou alterar sua escolha a qualquer momento.</p>
      <a href="/privacidade" className="text-sm text-primary underline">Política de privacidade</a>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button variant="outline" onClick={() => window.usaAdvertising?.choose(false)}>Recusar</Button>
        <Button variant="outline" onClick={() => window.usaAdvertising?.choose(true)}>Aceitar</Button>
        <Button variant="ghost" onClick={() => setOpen(false)}>Fechar</Button>
      </div>
    </section>}
  </>;
}